import React from 'react';
import { Link } from 'react-router-dom';
import './Docs.css';

// Pricing mental model page — calm, informational, no numbers.
export default function Pricing() {
  return (
    <div className="docs-lite">
      <header className="docs-lite__header">
        <h1>JG Presence Engine — Pricing Mental Model</h1>
        <p className="docs-lite__lede">How presence is priced, before numbers.</p>
      </header>

      <main className="docs-lite__content">
        <section>
          <h2>What you’re paying for</h2>
          <p>JG Presence Engine is priced around live signals, not features.</p>
          <p>You are not paying for connections, users, rooms, or messages.</p>
          <p>You are paying for the continuous cost of maintaining real-time system truth.</p>
        </section>

        <section>
          <h2>Active sessions</h2>
          <p>Presence exists while a session is alive.</p>
          <p>Guest sessions, authenticated sessions, and background states all contribute to live system load.</p>
          <p>More active sessions require more real-time state management.</p>
        </section>

        <section>
          <h2>Concurrency (density)</h2>
          <p>Presence cost scales with how many sessions are live at the same time.</p>
          <p>Concurrency, not total users, is the dominant cost driver.</p>
          <p>A product with many users but low concurrency behaves very differently from one with high simultaneous presence.</p>
        </section>

        <section>
          <h2>Lifecycle depth</h2>
          <p>Presence is not binary.</p>
          <p>Tracking lifecycle states such as active, idle, background, away, reconnects, and promotions adds semantic richness and computational cost.</p>
          <p>Deeper lifecycle modeling provides higher value and requires more system resources.</p>
        </section>

        <section>
          <h2>Observability</h2>
          <p>JG Presence Engine exposes presence as a system-level signal.</p>
          <p>This includes aggregation, density awareness, cross-surface visibility, and surge detection.</p>
          <p>Observability transforms presence from a feature into a platform capability.</p>
        </section>

        <section>
          <h2>Why this differs from feature pricing</h2>
          <p>Most systems price features, tiers, or seats.</p>
          <p>Presence is continuous, stateful, time-based, and load-sensitive.</p>
          <p>Pricing it as a static feature leads to unfair outcomes.</p>
        </section>

        <section>
          <h2>Philosophy</h2>
          <p>JG Presence Engine does not monetize presence as a checkbox.</p>
          <p>It monetizes the responsibility of maintaining live system truth.</p>
        </section>

        {/* Cross-navigation strip for docs cohesion */}
        <div className="docs-lite__xnav">
          <a href="https://www.joegalaxy.net/presence-demo">← Back to live presence</a>
          <span style={{ padding: '0 8px' }}>|</span>
          <Link to="/docs">Docs</Link> · <Link to="/docs/quickstart">5-Minute Quickstart</Link> ·{' '}
          <Link to="/docs/pricing">Pricing model</Link>
        </div>
      </main>
    </div>
  );
}
